export async function getBatteryLevel() {
    const battery = await navigator.getBattery?.();

    return battery?.level ? battery.level * 100 : 0;
}
